var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SidebarChild", {
    attrs: {
      "selected-item": _vm.value,
      items: _vm.ChatbotMenuItems,
      focusActive: true,
      "default-open": "",
      className: "chatbot-menu",
    },
    on: { selected: _vm.selectedItem },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }